import theme from '../../../lib/theme';

const {
  corners,
  scale,
  shadows,
  layouts,
  colors,
  media,
  font: {
    families,
    heights,
    spacings,

    ...font
  },
} = theme;

export default () => ({
  link: {
    textDecoration: 'none',

    '&:hover, &:hover > *': {
      textDecoration: 'none !important',
    },

    '&:hover .Story__title': {
      textDecoration: 'underline',
      color: colors.sas.primary,
    },

    '&:hover .Story__image': {
      boxShadow: shadows.lowest,
    },
  },

  text: {
    ...layouts.spacedColumn('xxxs'),

    flex: 'auto',
  },

  showMore: {
    textDecoration: 'underline',
    display: 'block',
    marginTop: scale.xxxs,
    transition: 'all 150ms linear',
    color: colors.sas.primary,
    fontWeight: font.bold,

    '&:hover': {
      color: colors.sas.accent,
    },

    [media.l.up]: {
      display: 'inline',
      marginTop: 0,
    },
  },

  image: {
    backgroundColor: colors.grey,
    width: '100%',
    borderRadius: corners.m,
    border: `1px solid ${colors.grey}`,
  },

  title: {
    transition: 'all 150ms linear',
  },

  teaser: {
    ...layouts.column,

    backgroundColor: '#ffeffa',
    borderRadius: corners.m,
    alignItems: 'flex-start',
    padding: scale.s,

    '& > *': {
      marginBottom: scale.s,
    },

    '& > *:last-child': {
      marginBottom: 0,
    },

    [media.s.up]: {
      ...layouts.row,

      alignItems: 'flex-start',

      '& > *': {
        marginRight: scale.m,
        marginBottom: 0,
      },

      '& > *:last-child': {
        marginRight: 0,
      },
    },

    [media.l.up]: {
      alignItems: 'center',
    },
  },

  icon: {
    width: 74,
    paddingBottom: 10,
    margin: '0 !important',

    [media.s.up]: {
      marginRight: `${scale.m} !important`,
    },

    [media.l.up]: {
      backgroundPosition: 'center',
    },
  },
});
